'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import styled from 'styled-components';
import breakpoint from '../../utils/responsiveBreakpoints';
import { OLAF, CALYPSO, OZ, PANTERA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { NavItemEnum, SidenavConfig } from '../../constants/Mon569SidenavConfig';
import UIRouterSideNav from 'ui-addon-react-router-dom/UIRouterSideNav';
import UIRouterSideNavItem from 'ui-addon-react-router-dom/UIRouterSideNavItem';
import Mon569MobileTabs from './Mon569MobileTabs';
import SegmentedTabs from './SegmentedTabs';
import { useParams } from 'react-router-dom';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { useSelector } from 'react-redux';
import { isAppAuthSelector } from '../../selectors/ConfigSelectors';
import StandardProductPageTitle from '../product-pages/StandardProductPageTitle';
import { Mon569HubSubtitle } from '../common/HubSubtitle';
import CalculatorAnchorLink from '../common/CalculatorAnchorLink';
import UIIntersectionObserver from 'UIComponents/observer/UIIntersectionObserver';
import StickyTabs from './StickyTabs';
import { useState } from 'react';
import { SuiteTitleSection } from '../suite-page/CrmSuiteTopSection';
const PricingPageTitle = styled.h1.withConfig({
  displayName: "NavLayout__PricingPageTitle",
  componentId: "sc-10zvphh-0"
})(["font-size:28px;color:", ";"], OLAF);
const PricingPageSubtitle = styled.p.withConfig({
  displayName: "NavLayout__PricingPageSubtitle",
  componentId: "sc-10zvphh-1"
})(["font-size:14px;color:", ";.pricing-page-subtitle-link{text-decoration:underline;color:", ";}"], OLAF, OLAF);
const HeaderTitle = styled.div.withConfig({
  displayName: "NavLayout__HeaderTitle",
  componentId: "sc-10zvphh-2"
})(["position:relative;text-align:center;", ""], breakpoint.cs(_t || (_t = _`
    padding: 0 15px;
    margin-left: 0;
  `)));
const HeaderGradient = styled.div.withConfig({
  displayName: "NavLayout__HeaderGradient",
  componentId: "sc-10zvphh-3"
})(["position:absolute;background-color:#00bda5;background-image:linear-gradient( -303deg,", ",0%,#00afb2 56%,", " 100% );width:100%;height:130px;"], CALYPSO, OZ);
const SideNavContainer = styled.div.withConfig({
  displayName: "NavLayout__SideNavContainer",
  componentId: "sc-10zvphh-4"
})(["z-index:1;min-width:200px;& > nav > h2{text-align:left;font-weight:400;font-size:24px;}& > nav > ul{margin-left:12px;margin-right:12px;}& > nav > hr{background-color:", ";width:90%;}", ";"], PANTERA, breakpoint.cs(_t2 || (_t2 = _`
    display: none;
  `)));
const ContentContainer = styled.div.withConfig({
  displayName: "NavLayout__ContentContainer",
  componentId: "sc-10zvphh-5"
})(["width:100%;"]);
const StyledFlexContainer = styled(UIFlex).withConfig({
  displayName: "NavLayout__StyledFlexContainer",
  componentId: "sc-10zvphh-6"
})(["top:-1px;max-width:1200px;margin:auto;margin-top:40px;"]);
const TabHeaderContainer = styled.div.withConfig({
  displayName: "NavLayout__TabHeaderContainer",
  componentId: "sc-10zvphh-7"
})(["margin-left:50px;"]);
export const HeaderBackdrop = () => {
  const isInApp = useSelector(isAppAuthSelector);
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(HeaderGradient, {}), /*#__PURE__*/_jsxs(HeaderTitle, {
      isInApp: isInApp,
      children: [/*#__PURE__*/_jsx(PricingPageTitle, {
        className: "p-top-8 p-bottom-2 m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.title"
        })
      }), /*#__PURE__*/_jsx(PricingPageSubtitle, {
        className: "p-bottom-8 m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.subTitle"
        })
      })]
    })]
  });
};

const NavLayout = ({
  children,
  selectedNavItem
}) => {
  const navItems = Object.keys(SidenavConfig);
  const splitIndex = navItems.indexOf('bundle');
  const navLists = [navItems.slice(0, splitIndex), navItems.slice(splitIndex)];
  const [isTabsIntersecting, setIsTabsIntersecting] = useState(true);
  const {
    tab: selectedTab
  } = useParams();

  const getHideTabs = navItem => navItem === NavItemEnum.BUNDLE || navItem === NavItemEnum.CRM;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Mon569MobileTabs, {
      selectedItem: selectedNavItem
    }), /*#__PURE__*/_jsx(StickyTabs, {
      isTabsIntersecting: isTabsIntersecting,
      selectedNavItem: selectedNavItem
    }), /*#__PURE__*/_jsxs(StyledFlexContainer, {
      justify: "center",
      children: [/*#__PURE__*/_jsx(SideNavContainer, {
        children: isTabsIntersecting && navLists.map((navList, index) => /*#__PURE__*/_jsx(UIRouterSideNav, {
          "aria-label": `pricing-page-products-${index}`,
          headingText: index === 0 && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "mon569.sidenav.title"
          }),
          divider: index !== 0,
          children: navList.map(navItem => {
            const hideTabs = getHideTabs(navItem);
            const toValue = `/${SidenavConfig[navItem].id}${hideTabs ? '' : selectedTab ? `/${selectedTab}` : ''}`;
            return /*#__PURE__*/_jsx(UIRouterSideNavItem, {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: SidenavConfig[navItem].title
              }),
              className: selectedNavItem === navItem ? 'is-active' : undefined,
              to: createToObject(toValue)
            }, navItem);
          })
        }, navList[0]))
      }), /*#__PURE__*/_jsxs(ContentContainer, {
        children: [!getHideTabs(selectedNavItem) && (selectedNavItem === NavItemEnum.SUITE ? /*#__PURE__*/_jsx(SuiteTitleSection, {}) : /*#__PURE__*/_jsxs(TabHeaderContainer, {
          children: [/*#__PURE__*/_jsx(StandardProductPageTitle, {
            productLine: selectedNavItem.toUpperCase(),
            includeTrademark: selectedNavItem !== NavItemEnum.CMS,
            includeRegisteredTrademark: selectedNavItem === NavItemEnum.CMS
          }), /*#__PURE__*/_jsxs(Mon569HubSubtitle, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: `pricing-pages.hubs.${selectedNavItem}.description`
            }), /*#__PURE__*/_jsx(CalculatorAnchorLink, {})]
          })]
        })), /*#__PURE__*/_jsx(UIIntersectionObserver, {
          initialIntersecting: true,
          threshold: 1,
          onIntersectionChange: ({
            entries
          }) => setIsTabsIntersecting(entries[0].isIntersecting),
          renderContent: isIntersecting => /*#__PURE__*/_jsx(SegmentedTabs, {
            isIntersecting: isIntersecting,
            selectedNavItem: selectedNavItem
          })
        }), children]
      })]
    })]
  });
};

export default NavLayout;